import resizeSensor from "element-resize-detector";
import { debounce } from "kinnect-helpers";

export default {
	name: "ResizeWatchableMixin",

	data: () => ( {
		elHeight: null,
		elWidth: null,
		sensor: null
	} ),

	mounted() {
		this.sensor = resizeSensor( { strategy: "scroll" } );

		this.sensor.listenTo( this.$el, debounce( el => {
			this.elHeight = el.offsetHeight;
			this.elWidth = el.offsetWidth;
		}, 300 ) );
	},

	beforeDestroy() {
		this.sensor.uninstall( this.$el );
		this.sensor = null;
	}
};
